"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeCircle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.BadgeCircle = styled_components_1.default.div `
  position: absolute;
  top: -3px;
  right: -3px;

  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 14px;
  height: 14px;

  background-color: ${({ theme }) => theme.colors.accent.base};

  color: white;

  font-size: 0.625rem;
  font-weight: 500;

  border-radius: 50%;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    top: -10px;
    right: -10px;

    width: 20px;
    height: 20px;

    font-size: 0.875rem;
  }
`;
